"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSITY_LEADERBOARD = void 0;
const client_1 = require("@apollo/client");
exports.UNIVERSITY_LEADERBOARD = (0, client_1.gql) `
  query UniversityLeaderboard($limit: Int!) {
    restricted {
      universityLeaderboard(limit: $limit) {
        updatedAt
        month {
          id
          name
          speciality
          rank
        }
        quarter {
          id
          name
          speciality
          rank
        }
      }
    }
  }
`;
